import { useState, useEffect } from "react";
// Hook
const cachedScripts = {};
function useScript(src, options = {}) {
  // Keeping track of script loaded and error state
  const [state, setState] = useState({
    loaded: false,
    error: false,
    errorDetails: null
  });
  const localOptions = JSON.stringify(options);
  useEffect(
    () => {
      if (!src) {
        return;
      }
      // If cachedScripts array already includes src that means another instance ...
      // ... of this hook already loaded this script, so no need to load again.
      if (cachedScripts[src]) {
        if (cachedScripts[src].loaded) {
          setState({ loaded: true, error: false, errorDetails: null });
          return;
        }
        cachedScripts[src].loadingPromise
          .then(() => {
            cachedScripts[src].loaded = true;
            setState({ loaded: true, error: false, errorDetails: null });
          })
          .catch((error) => {
            setState({ loaded: false, error: true, errorDetails: error });
          });
        return;
      }
      const loadingPromise = new Promise((resolve, reject) => {
        // Create script
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        const parsedOptions = JSON.parse(localOptions);
        if (parsedOptions?.attr) {
          for (const [key, value] of Object.entries(parsedOptions.attr)) {
            script.setAttribute(key, value || "");
          }
        }
        const onScriptLoad = () => {
          cachedScripts[src].loaded = true;
          setState({ loaded: true, error: false, errorDetails: null });
          resolve();
        };
        const onScriptError = (error) => {
          delete cachedScripts[src];
          setState({ loaded: false, error: true, errorDetails: error });
          reject();
        };
        script.addEventListener("load", onScriptLoad);
        script.addEventListener("error", onScriptError);
        // Add script to document body
        document.body.appendChild(script);
      });

      if (!cachedScripts[src]) {
        cachedScripts[src] = {
          loaded: false,
          loadingPromise
        };
      }
    },
    [src, localOptions] // Only re-run effect if script src changes
  );
  return [state.loaded, state.error, state.errorDetails];
}
export default useScript;
